import { PRELOAD_DELAY_MS, PRELOAD_IDLE_TIMEOUT_MS } from "./constants";

/**
 * Preloading the other homepage costs its code and its API calls on every visit,
 * so it is skipped when the student has asked the browser to save data or is on
 * a 2G-class connection. They still switch, just without the head start.
 */
export const isPreloadAllowed = () => {
  const connection = navigator.connection;
  if (connection?.saveData) return false;
  return !["slow-2g", "2g"].includes(connection?.effectiveType);
};

/**
 * Runs `callback` after the visible homepage has had PRELOAD_DELAY_MS to load
 * undisturbed, at the browser's next idle moment.
 * @param {() => void} callback
 * @returns {() => void} cancels it
 */
export const scheduleWhenIdle = (callback) => {
  let idleId = null;
  const delayId = setTimeout(() => {
    idleId = window.requestIdleCallback
      ? window.requestIdleCallback(callback, {
          timeout: PRELOAD_IDLE_TIMEOUT_MS,
        })
      : setTimeout(callback, 0);
  }, PRELOAD_DELAY_MS);

  return () => {
    clearTimeout(delayId);
    if (idleId === null) return;
    if (window.cancelIdleCallback) window.cancelIdleCallback(idleId);
    else clearTimeout(idleId);
  };
};
